import { TaskSearchFilterName } from './TaskFilterUtilitis';
export interface ITaskSelectedFilters {
  filterTypeId?: number;
  dueDateStart?: string;
  dueDateEnd?: string;
  searchText?: string;
  [TaskSearchFilterName.taskName]?: string[];
  [TaskSearchFilterName.taskCategory]?: number[];
  [TaskSearchFilterName.placementId]?: number[];
  [TaskSearchFilterName.candidateId]?: number[];
  [TaskSearchFilterName.facilityId]?: number[];
  [TaskSearchFilterName.orderId]?: number[];
  [TaskSearchFilterName.status]?: number[];
  [TaskSearchFilterName.assignedTo]?: number[];
  [TaskSearchFilterName.createdBy]?: number[];
}

export const defaultTaskFilters: ITaskSelectedFilters = {
  taskName: [],
  taskCategories: [],
  candidateIds: [],
  placementIds: [],
  facilityIds: [],
  orderIds: [],
  assignedToIds: [],
  createdByIds: [],
  taskStatusIds: [1, 2],
};
